import Card from "../../../Components/Cards/Account/Container";
import SimpleGray from "../../../Components/Buttons/SimpleGray";
import GradientCustom from "../../../Components/Buttons/GradientCustom";
import { useState } from "react";
import ResetAccountModal from "./ResetAccountModal";
export default function Cards({
  color,
  account,
  user,
  accountType,
  setIsLoading,
  isLoading,
  setModalClosed,
}) {
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  let simpleGrayText = "";
  let hideSimpleGray = false;

  let simpleGrayHref;
  let simpleGrayOnClick;

  if (color === "blue") {
    simpleGrayText = "معامله";
    simpleGrayHref = `/trade/${account.code}/trade`;
  } else if (color === "yellow") {
    simpleGrayText = "فعال کردن";
    simpleGrayOnClick = () => setIsResetModalOpen(true);
  } else if (color === "green" || color === "red") {
    hideSimpleGray = true;
  }
  return (
    <>
      <div className="w-full max-w-96 flex flex-col gap-3">
        <Card
          color={color}
          account={account}
          user={user}
          accountType={accountType}
          setIsLoading={setIsLoading}
        />
        {!isLoading && (
          <div className="flex gap-8">
            <GradientCustom
              text="جزئیات حساب"
              color={color}
              href={`/challenge/account/${account.code}/overview`}
            />
            {hideSimpleGray ? (
              <div className="w-full invisible">
                <SimpleGray text="" />
              </div>
            ) : (
              <SimpleGray
                text={simpleGrayText}
                href={simpleGrayHref}
                onClick={simpleGrayOnClick}
              />
            )}
          </div>
        )}
      </div>
      {isResetModalOpen && (
        <ResetAccountModal
          account={account}
          onClose={() => setIsResetModalOpen(false)}
          onSuccessClose={() => {
            setModalClosed(true);
            setIsResetModalOpen(false);
          }}
        />
      )}
    </>
  );
}
